import { type AxiosInstance } from "axios";
import type { PropertyInfoResponse } from "@/features/propertyCodeAcquisition/types";

// 物件情報（画面ヘッダー）取得の API 呼び出し層。
// hook（usePropertyInfo）は SWR の設定・状態管理に専念し、HTTP 呼び出しは本 fetcher に集約する。

/** 物件情報取得エンドポイントを生成する。GET /api/property-codes/{code}（baseURL が /api を付与）。 */
export const buildPropertyInfoEndpoint = (propertyCode: string): string =>
  `/property-codes/${propertyCode}`;

/**
 * 物件情報（画面ヘッダー）を取得する fetcher。
 * 404 等のエラーは throw し、HTTP ステータスによる判定は呼び出し側（コンテナ）で行う。
 * @param apiClient JWT 認証付き apiClient
 * @param propertyCode 物件コード（UUID）
 */
export const getPropertyInfo = async (
  apiClient: AxiosInstance,
  propertyCode: string
): Promise<PropertyInfoResponse> => {
  const { data } = await apiClient.get<PropertyInfoResponse>(
    buildPropertyInfoEndpoint(propertyCode)
  );
  return data;
};
